import { useSelector } from "react-redux";
import { Axios } from "../hooks/useAxiosInstance";

export const UserManagement = (function () {
  // const { api_token } = useSelector(state => state.profile);

  const apis = () => ({
    fetch: async ({ api_token }) => await fetchRecord(api_token),
    update: async ({ data, api_token }) => await updateRecord(data, api_token),
    delete: async (slug, api_token) => await deleteRecord(slug, api_token),
  });

  async function fetchRecord(api_token) {
    const url = "api/admin/user-management";
    const option = {
      headers: {
        Authorization: api_token,
        "Content-Type": "application/json",
      },
    };

    return await Axios.get(url, option);
  }

  async function updateRecord(data, api_token) {
    const url = "api/admin/user-management";
    const option = {
      headers: {
        Authorization: api_token,
        "Content-Type": "application/json",
      },
    };

    return await Axios.patch(url, data, option);
  }
  async function deleteRecord(slug, api_token) {
    const url = "api/admin/user-management/" + slug;
    const option = {
      headers: {
        Authorization: api_token,
        "Content-Type": "application/json",
      },
    };

    return await Axios.delete(url, option);
  }

  return apis();
})();
